import { SidebarProvider, useSidebar } from "../../../context/SidebarContext";
import { Outlet } from "react-router";
import EmployeeAppSidebar from "./EmployeeAppSidebar";
import EmployeeBackdrop from "./EmployeeBackdrop";
import EmployeeAppHeader from "./EmployeeAppHeader";


const LayoutContent = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();

  return (
    <div className="min-h-screen xl:flex">
      <div>
        <EmployeeAppSidebar />
        <EmployeeBackdrop />
      </div>
      <div
        className={`flex-1 transition-all duration-300 ease-in-out ${
          isExpanded || isHovered ? "lg:ml-[290px]" : "lg:ml-[90px]"
        } ${isMobileOpen ? "ml-0" : ""}`}
      >
        <EmployeeAppHeader />
        <div className="p-4 mx-auto max-w-(--breakpoint-2xl) md:p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

const EmployeeAppLayout = () => {
  return (
    <SidebarProvider>
      <LayoutContent />
    </SidebarProvider>
  );
};

export default EmployeeAppLayout;
